module.exports = __webpack_public_path__ + "img/Spectra Icon_Up.7662ca33.svg";